import { Box } from "@twilio-paste/core/box";
import { css, styled } from "@twilio-paste/styling-library";

export const Container = styled(Box)(() =>
    css({
        display: "grid",
        gridTemplateColumns: "2fr 1fr",
        gridTemplateAreas: [
            `
          "heading heading"
          "separator separator"
          "cont cont"
          "right right"`,
            `
        "heading heading"
        "separator separator"
        "cont cont"
        "right right"`,
            `
        "heading heading"
        "separator separator"
        "cont cont"
        "right right"`,

            `
        "heading ."
        "separator separator"
        "cont right"`
        ],
        paddingTop: "space100",
        paddingX: ["space100", "space100", "space0"]
    })
);
